// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { compareAsc } from 'date-fns'
import getEnv from '@/utils/env'

const baseUrl = getEnv('VUE_APP_IIIF_URL') || '/pathds/api/v1/iiif/patient/'

const callPathologyWithTimeout = async (patientId, baseUrl) => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }

    const url = `${baseUrl}${patientId}/biopsy/collection`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }

    const results = await response.json()
    if (!results) { return [] }

    results.items.sort((a, b) => compareAsc(new Date(b.biopsy_time), new Date(a.biopsy_time)))
    return results.items
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}

export const getPathology = async (patientId) => {
  return await callPathologyWithTimeout(patientId, baseUrl)
}
